import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
    selector: 'app-page-action-pane',
    standalone: true,
    template: `
        <aside class="page-action-pane">
            <div class="action-pane-heading">
                <i class="pi pi-bolt"></i>
                <div>
                    <h2>{{ title }}</h2>
                    @if (subtitle) {
                        <p>{{ subtitle }}</p>
                    }
                </div>
            </div>
            <div class="action-pane-content">
                <ng-content></ng-content>
            </div>
        </aside>
    `,
    styles: [`
        :host { display: block; min-width: 0; }
        .page-action-pane {
            position: sticky;
            top: var(--shell-sticky-pane-top, 78px);
            display: grid;
            gap: .85rem;
            padding: 1rem;
            border: 1px solid var(--app-border, #dfe7f3);
            border-top: 4px solid var(--app-accent, #0ea5a3);
            border-radius: 10px;
            background: var(--app-surface, #ffffff);
            box-shadow: 0 10px 24px var(--app-shadow-soft, rgba(15, 23, 42, .06));
        }
        .action-pane-heading { display: grid; grid-template-columns: 2rem minmax(0, 1fr); align-items: start; gap: .65rem; padding: 0 .15rem .25rem; }
        .action-pane-heading > i {
            display: inline-flex; align-items: center; justify-content: center;
            width: 2rem; height: 2rem; border-radius: 7px;
            color: var(--app-primary, #0f766e); background: #ecfdf5;
        }
        h2 { margin: 0; color: var(--app-text, #172033); font-size: 1.08rem; }
        p { margin: .2rem 0 0; color: var(--app-muted, #64748b); font-size: .8rem; line-height: 1.35; }
        .action-pane-content { display: grid; gap: .75rem; }
        :host ::ng-deep .action-section {
            display: grid;
            gap: .6rem;
            padding: .8rem;
            border: 1px solid var(--app-border, #dfe7f3);
            border-radius: 8px;
            background: var(--app-surface-2, #f8fafc);
        }
        :host ::ng-deep .action-section--primary {
            border-color: var(--green-200, #bbf7d0);
            background: var(--green-50, #f0fdf4);
        }
        :host ::ng-deep .action-section-title {
            display: flex; align-items: center; gap: .4rem;
            color: var(--app-text, #172033); font-size: .82rem; font-weight: 800;
            letter-spacing: .04em; text-transform: uppercase;
        }
        :host ::ng-deep .action-section-title::before {
            content: ''; width: .42rem; height: .42rem; flex: 0 0 .42rem;
            border-radius: 50%; background: var(--app-accent, #0ea5a3);
        }
        :host ::ng-deep .action-buttons, :host ::ng-deep .workflow-actions {
            display: grid; grid-template-columns: 1fr; align-items: stretch; gap: .5rem;
        }
        :host ::ng-deep app-accounting-workflow-actions { display: block; }
        :host ::ng-deep app-accounting-workflow-actions .workflow-actions { display: grid; width: 100%; }
        :host ::ng-deep p-button { display: block; width: 100%; }
        :host ::ng-deep .p-button { width: 100%; min-height: 2.6rem; justify-content: flex-start; border-radius: 7px; }
        :host ::ng-deep .p-button .p-button-label { flex: 1 1 auto; text-align: left; }
        @media (max-width: 1080px) {
            .page-action-pane { position: static; }
            :host ::ng-deep .action-buttons, :host ::ng-deep .workflow-actions { grid-template-columns: repeat(auto-fit, minmax(12rem, 1fr)); }
        }
    `],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PageActionPaneComponent {
    @Input() title = 'Actions';
    @Input() subtitle = '';
}
